<template>
    <header ref="header" class="header">
        <b-row align-h="between">
            <b-col>
                <b-link target="_blank" href="https://anih.culture.tw/index/en-us">
                    <b-img :src="require('@/assets/img/logo.png')" fluid alt="Responsive image" class="logo"></b-img>
                </b-link>
                <h1 class="title">{{ $t('site_title')}}</h1>
            </b-col>
            <b-col sm="12" md="auto">
                <b-nav class="justify-content-end">
                    <b-nav-item-dropdown :text="$t('language')" right>
                        <b-dropdown-item v-for="(item, index) in optionsLang" v-bind:key="index" href="#"
                            v-on:click="setLang(item.value)">{{ item.text }}</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-nav>
            </b-col>
        </b-row>
    </header>
</template>

<script>
    export default {
        name: 'Header',
        data() {
            return {
                optionsLang: [{
                        text: '中文',
                        value: 'tc'
                    },
                    {
                        text: 'English',
                        value: 'en'
                    }
                ]
            }
        },
        mounted() {
            this.matchHeight();
        },
        methods: {
            // 儲存切換的語系
            setLang(value) {
                this.$store.commit('setLang', value);
                this.$i18n.locale = value;
                localStorage.setItem('lang-mark', value);
            },
            matchHeight() {}
        },
        props: {
            isOther: Boolean
        }
    }
</script>